import Model from "./base/model";

class CompanyExtraPlanValue extends Model{
  resourceName() {
    return "company_extra_plan_values";
  }

  fields() {
    return {
      company_id: "",
      quantity: "",
      price: "",
      extra_plan_id: "",
      extra_plan_name: "",
      company: { jsonApi: "hasOne", type: "companies" },
    }
  }
}

export default new CompanyExtraPlanValue();
